// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorSiteAccountUpsearchRequestModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorSiteAccountUpsearchRequestModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorSiteAccountUpsearchRequestModel.discriminator = undefined;
EnterpriseCoordinatorSiteAccountUpsearchRequestModel.additionalProperties = false;
EnterpriseCoordinatorSiteAccountUpsearchRequestModel.attributeTypeMap = [
    {
        "name": "partyData",
        "baseName": "partyData",
        "type": "UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel"
    },
    {
        "name": "accountData",
        "baseName": "accountData",
        "type": "UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel"
    },
    {
        "name": "diagnosisSessionData",
        "baseName": "diagnosisSessionData",
        "type": "EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel"
    },
    {
        "name": "payorData",
        "baseName": "payorData",
        "type": ""
    },
    {
        "name": "pharmacyData",
        "baseName": "pharmacyData",
        "type": ""
    },
    {
        "name": "prescriberData",
        "baseName": "prescriberData",
        "type": ""
    },
    {
        "name": "prescriptionData",
        "baseName": "prescriptionData",
        "type": ""
    },
    {
        "name": "siteData",
        "baseName": "siteData",
        "type": ""
    },
    {
        "name": "surveySessionData",
        "baseName": "surveySessionData",
        "type": ""
    },
];
//# sourceMappingURL=enterpriseCoordinatorSiteAccountUpsearchRequestModel.js.map